import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Page } from '../../../utils/page';
import { ProductSearchRequest } from '../../../models/quote/product-search-request';
import { Observable } from 'rxjs';
import { ProductsByServicesRequest } from '../../../models/quote/products-by-services-request';
import { map } from 'rxjs/operators';
import { ProductClassificationRequest } from '../../../models/quote/product-classification-request';
import { CmcProductManagerService } from "./cmc-product-manager.service";
import { PriceList } from '../../../models/productv2/pricelist.model';
import { ProductWithChildrenV2 } from 'src/app/core/models/productv2/productv2-children.model';
import { ProductMapperV2Service } from '../product-mapper-v2.service';

@Injectable()
export class RemoteCmcProductManagerService extends CmcProductManagerService {

    API_URL = '/apiCmcProductManager/v1/cmc-product-manager';

    constructor(private http: HttpClient, protected productMapper: ProductMapperV2Service) {
        super(productMapper);
    }

    searchArticles(productSearchRequest: ProductSearchRequest, pageable: Map<string, string>): Observable<Page<ProductWithChildrenV2>> {
        let params = new HttpParams();
        pageable.forEach((value, key) => params = params.set(key, value));
        const url = `${this.API_URL}`;
        return this.http.post<Page<any>>(url, productSearchRequest, { params }).pipe(
            map(page => {
                const mappedContent = page.content.map(item => this.productMapper.mapToProductWithChildrenV2(item));
                return { ...page, content: mappedContent };
            })
        );
    }

    searchArticlesByFilteredElisCodes(requestData: ProductsByServicesRequest): Observable<{ content: ProductWithChildrenV2[] }> {
        const url = `${this.API_URL + '/search/duplicate'}`;
        if (!Object.keys(requestData.codesByService).length) {
            return new Observable(observer => {
                observer.next({ content: [] });
                observer.complete();
            });
        }
        return this.http.post<any[]>(url, requestData).pipe(
            map(responses =>
                responses.flatMap(r =>
                    (r.products ?? []).map(p => this.productMapper.mapToProductWithChildrenV2(p))
                )
            ),
            map(products => ({ content: products }))
        );
    }

    searchClassifications(productClassificationRequest: ProductClassificationRequest): Observable<PriceList[]> {
        const url = `${this.API_URL + '/classification'}`;
        return this.http.post<any[]>(url, productClassificationRequest).pipe(
            map(result => result.map(classification => this.productMapper.mapToPriceList(classification)))
        );;
    }

}
